/**
 * airan-ntn — Interference Management xApp
 * Nulls interference between beams and cells
 */

import { XAppBase } from './XAppBase.js';
import { E2KpmReport, E2RcAction, XAppDecision } from '../types.js';

export class InterferenceMgmtXApp extends XAppBase {
  private lastReports: Map<number, E2KpmReport> = new Map();

  constructor(enabled: boolean = true) {
    super('interference-mgmt', enabled);
  }

  processKpmReport(report: E2KpmReport): void {
    this.lastReports.set(report.gnbId, report);
  }

  decisionCycle(): XAppDecision {
    const start = performance.now();
    const actions: E2RcAction[] = [];

    for (const [gnbId, report] of this.lastReports) {
      const avgSinr = report.ueReports.reduce((sum, ue) => sum + ue.sinr, 0) / Math.max(1, report.ueReports.length);
      if (avgSinr < 10) {
        actions.push({
          type: 'INTERFERENCE_NULLING',
          targetId: gnbId,
          payload: { method: 'zero_forcing', targetBeams: [0, 1, 2] },
          priority: this.config.priority,
          timestamp: Date.now()
        });
      }
    }

    const latency = performance.now() - start;
    this.recordDecision(latency);

    return { actions, confidence: 0.85, latencyMs: latency };
  }

  getRequiredSubscription(): { eventTriggers: string[]; reportStyle: string } {
    return {
      eventTriggers: this.config.requiredEventTriggers,
      reportStyle: this.config.requiredReportStyle
    };
  }
}